export const TITLE_ONLY = Symbol('TITLE_ONLY')
